import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Wayf } from 'components/atoms';
import { PublicLayout } from 'components/layout';
import { WayfPageDemoStyled } from './WayfPageDemo.styles';

const WayfPageDemo = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user.auth.wayfPage',
  });

  const onStructureSelect = useCallback(() => {
    // nothing
  }, []);

  return (
    <PublicLayout
      backButtonText={t('return')}
      title={t('yourStructure')}
      breadcrumb={[
        {
          name: t('yourStructure'),
        },
      ]}
    >
      <WayfPageDemoStyled>
        <div className="wayf_container">
          <div className="wayf_inner">
            {/* <p className="instruction">{tWayfPageDemo('instruction')}</p> */}
            <Wayf
              onStructureSelect={onStructureSelect}
              domain=""
              showBtn={true}
              demo={true}
            />
          </div>
        </div>
      </WayfPageDemoStyled>
    </PublicLayout>
  );
};

export default WayfPageDemo;
